import {useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import ColorMediaEditor from './ColorMediaEditor';
import SafeColorPicker from './SafeColorPicker';
import './safe-color-picker.css';

const {FiArrowDown,FiArrowUp,FiPlus,FiTrash2}=FiIcons;

function ProductColorEditor({colors=[],onChange}) {
  const [newColor,setNewColor]=useState('');
  const [newHex,setNewHex]=useState('#c99a45');

  const updateColor=(index,nextColor)=> {
    onChange(colors.map((color,itemIndex)=>
      itemIndex===index ? nextColor : color
    ));
  };

  const moveColor=(index,direction)=> {
    const nextIndex=index + direction;
    if (nextIndex < 0 || nextIndex >= colors.length) return;
    const reordered=[...colors];
    [reordered[index],reordered[nextIndex]]=[
      reordered[nextIndex],
      reordered[index]
    ];
    onChange(reordered);
  };

  const removeColor=(index)=> {
    onChange(colors.filter((_,itemIndex)=> itemIndex !==index));
  };

  const addColor=()=> {
    if (!newColor.trim()) return;
    onChange([
      ...colors,
      {
        id: `temp-${crypto.randomUUID()}`,
        name: newColor.trim(),
        hex: newHex,
        quantity: 10,
        image_url: '',
        media: []
      }
    ]);
    setNewColor('');
    setNewHex('#c99a45');
  };

  return (
    <div className="product-color-editor">
      <div className="color-list">
        {colors.map((color,index)=> (
          <section className="color-item-card" key={color.id || index}>
            <div className="product-color-order-controls">
              <span className="product-color-order-label">
                Website display order · {index + 1}
              </span>
              <div>
                <button
                  type="button"
                  className="product-color-order-button"
                  onClick={()=> moveColor(index,-1)}
                  disabled={index===0}
                  aria-label={`Move ${color.name || `color ${index + 1}`} earlier`}
                  title="Move color earlier"
                >
                  <SafeIcon icon={FiArrowUp} />
                  <span>Move up</span>
                </button>
                <button
                  type="button"
                  className="product-color-order-button"
                  onClick={()=> moveColor(index,1)}
                  disabled={index===colors.length - 1}
                  aria-label={`Move ${color.name || `color ${index + 1}`} later`}
                  title="Move color later"
                >
                  <SafeIcon icon={FiArrowDown} />
                  <span>Move down</span>
                </button>
              </div>
            </div>
            <div className="color-item-primary">
              <div className="color-field color-field-swatch">
                <span className="color-field-label">Preview</span>
                <span
                  className="color-swatch"
                  style={{background: color.hex || '#c99a45'}}
                />
              </div>
              <div className="color-field">
                <span className="color-field-label">Color Name</span>
                <input
                  type="text"
                  value={color.name || ''}
                  placeholder="e.g. Royal Blue"
                  aria-label={`Color ${index + 1} name`}
                  onChange={(event)=>
                    updateColor(index,{...color,name: event.target.value})
                  }
                />
              </div>
              <div className="color-field color-field-picker">
                <span className="color-field-label">Hex Code</span>
                <SafeColorPicker
                  value={color.hex || '#c99a45'}
                  label={`Color ${index + 1}`}
                  onChange={(hex)=> updateColor(index,{...color,hex})}
                />
              </div>
              <div className="color-field">
                <span className="color-field-label">Stock Qty</span>
                <input
                  className="color-stock-input"
                  type="number"
                  min="0"
                  value={color.quantity ?? 0}
                  placeholder="0"
                  aria-label={`Stock for ${color.name || `color ${index + 1}`}`}
                  onChange={(event)=>
                    updateColor(index,{
                      ...color,
                      quantity: Number(event.target.value)
                    })
                  }
                />
              </div>
              <button
                type="button"
                className="color-delete-button"
                onClick={()=> removeColor(index)}
              >
                <SafeIcon icon={FiTrash2} />
                Remove
              </button>
            </div>
            <ColorMediaEditor
              color={color}
              onChange={(nextColor)=> updateColor(index,nextColor)}
            />
          </section>
        ))}
      </div>

      {colors.length===0 && (
        <div className="empty-media-box">
          No colors added yet. Add each available outfit color below.
        </div>
      )}

      <div className="color-add-row color-add-row-simple">
        <div className="color-field">
          <span className="color-field-label">Color Name</span>
          <input
            type="text"
            value={newColor}
            onChange={(event)=> setNewColor(event.target.value)}
            placeholder="e.g. Sage Mint Green"
          />
        </div>
        <div className="color-field color-field-picker">
          <span className="color-field-label">Hex Code</span>
          <SafeColorPicker
            value={newHex}
            label="New color"
            onChange={setNewHex}
          />
        </div>
        <button
          type="button"
          className="admin-btn-secondary small color-add-btn"
          onClick={addColor}
        >
          <SafeIcon icon={FiPlus} />
          Add color
        </button>
      </div>
    </div>
  );
}

export default ProductColorEditor;